var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.137 11.396a1.25 1.25 0 0 1 0 2.486l-.128.007h-.01a1.25 1.25 0 0 1 0-2.5h.01zM12.133 11.396a1.25 1.25 0 0 1 0 2.486l-.128.007h-.01a1.25 1.25 0 0 1 0-2.5h.01zM17.137 11.396a1.25 1.25 0 0 1 0 2.486l-.128.007h-.01a1.25 1.25 0 0 1 0-2.5h.01z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.639c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
    clipRule: "evenodd"
  })));
};
export default Svg24;